/**
 * The heights cabinet trim stands at (claude-docs/2026-10-30-venus-full-line-design.md,
 * "Height"). Crown sits on the cabinet top with stacking between, and fills
 * whatever gap there is to the ceiling: cut off AT the ceiling when the gap is
 * smaller than it, none at all over a cabinet whose top is the ceiling. Crown
 * never lies over the doors and never moves a cabinet (the user chose "A",
 * 2026-10-30). Light rail hangs under an upper's bottom. Pure; metres.
 */

/** A cabinet top this close to the ceiling has no gap to fill (the strips' touch tolerance). */
const CEILING_TOUCH_M = 0.01;

const topOf = (o) => o.center.y + o.dimensions.y / 2;
const bottomOf = (o) => o.center.y - o.dimensions.y / 2;

/**
 * Where a carrier's crown stands, or null where there is no gap above it.
 *
 * @param {Object} carrier  a cabinet with `center` / `dimensions`
 * @param {{ crown: TrimProfile, stacking: TrimProfile|null }} trim
 * @param {number} ceilingY  world Y of the ceiling over it
 * @returns {null | { bottomY, stackingTopY, topY, cut: boolean }}
 */
function crownBand(carrier, { crown, stacking }, ceilingY) {
  const bottomY = topOf(carrier);
  if (ceilingY - bottomY < CEILING_TOUCH_M) return null;
  const stackingTopY = bottomY + (stacking ? stacking.heightM : 0);
  const wantedTopY = stackingTopY + crown.heightM;
  return {
    bottomY,
    stackingTopY: Math.min(stackingTopY, ceilingY),
    topY: Math.min(wantedTopY, ceilingY),
    cut: wantedTopY > ceilingY,
  };
}

/** Where a carrier's light rail hangs: its profile's height under the carrier. */
function lightRailBand(carrier, profile) {
  const topY = bottomOf(carrier);
  return { bottomY: topY - profile.heightM, topY };
}

/** The tallest profile no taller than the gap, or null when none fits. */
function largestFittingProfile(profiles, gapM) {
  return (profiles || [])
    .filter((p) => p.heightM <= gapM)
    .reduce((best, p) => (!best || p.heightM > best.heightM ? p : best), null);
}

module.exports = {
  CEILING_TOUCH_M,
  crownBand,
  lightRailBand,
  largestFittingProfile,
};
